import type {
    RMTopology as PageTopology,
    RendererModel as RendererModelFull,
    RendererModelForServer as RendererModelServer,
    DocumentServicesModel as DocumentServicesModelFull,
    DocumentServicesModelForServer as DocumentServicesModelForServerType
} from '@wix/document-services-types'

/*TODO - move all references to document-services-type and remove this file*/
export type RMTopology = PageTopology

export type RendererModel = RendererModelFull

export type RendererModelForServer = RendererModelServer

export type DocumentServicesModel = DocumentServicesModelFull

export type DocumentServicesModelForServer = DocumentServicesModelForServerType

export interface ServiceTopology {}
